import React, { useState, useRef, useEffect, useContext } from "react";
import PermissionContext from "../../Store/permission-context";
import { Row, Col, Form, Card, Button, Table } from "react-bootstrap";
import classes from "./SupplyIn.module.css";
import { AutoComplete, Divider } from "rsuite";
import "rsuite/dist/rsuite.css";
import ModalOkay from "./Modals/ModalOkay";
import UploadInvoiceModal from "./Modals/UploadInvoiceModal";
import InputText from "../Elements/InputText.jsx";
import InputSelect from "../Elements/InputSelect.jsx";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
const SupplyIn = () => {
  const PCtx = useContext(PermissionContext);
  const [GoodID, setGoodID] = useState("");
  const [Itemname, setItemname] = useState("");
  const [SoldIn, setSoldIn] = useState("Unit");
  const [QBulk, setQBulk] = useState("");
  const [QUnit, setQUnit] = useState("");
  const [CostPrice, setCostPrice] = useState("");
  const [TotalCostPrice, setTotalCostPrice] = useState("");
  const [Converter, setConverter] = useState("1");
  const [SP1, setSP1] = useState("");
  const [SP2, setSP2] = useState("");
  const [SP3, setSP3] = useState("");
  const [UP1, setUP1] = useState("");
  const [UP2, setUP2] = useState("");
  const [UP3, setUP3] = useState("");
  const [ISP1, setISP1] = useState("");
  const [ISP2, setISP2] = useState("");
  const [ISP3, setISP3] = useState("");
  const [IUP1, setIUP1] = useState("");
  const [IUP2, setIUP2] = useState("");
  const [IUP3, setIUP3] = useState("");
  const [IQBulk, setIQBulk] = useState("");
  const [IQUnit, setIQUnit] = useState("");
  const [Dates, setDates] = useState("");
  const [DateCategory, setDateCategory] = useState("specific");
  const [SingleDate, setSingleDate] = useState("");
  const [HasNotUploaded, setHasNotUploaded] = useState(true);
  const [IConverter, setIConverter] = useState("");
  const [AxiosError, setAxiosError] = useState("");
  const [bulkvalue, setbulkvalue] = useState("Unit");
  const [checkup, setcheckup] = useState(true);
  const [checksp, setchecksp] = useState(true);
  const [ErrorSP1, setErrorSP1] = useState(false);
  const [ErrorSP2, setErrorSP2] = useState(false);
  const [ErrorSP3, setErrorSP3] = useState(false);
  const [ErrorUP1, setErrorUP1] = useState(false);
  const [ErrorUP2, setErrorUP2] = useState(false);
  const [ErrorUP3, setErrorUP3] = useState(false);
  const [ItHasBulk, setItHasBulk] = useState(false);
  const [convreadonly, setconvreadonly] = useState(false);
  const [ItemHasChanged, setItemHasChanged] = useState(false);
  const [AllGoodNames, setAllGoodNames] = useState([]);
  const [AllGoodIds, setAllGoodIds] = useState([]);
  const [Itemdetails, setItemdetails] = useState([]);
  const [OpenSupplyForm, setOpenSupplyForm] = useState(false);
  const [Supplier, setSupplier] = useState("Anonymous");
  const [InvoiceNumber, setInvoiceNumber] = useState("XXXXXX");
  const [ItemsEntered, setItemsEntered] = useState([]);
  const [TotalInvoiceCost, setTotalInvoiceCost] = useState(0);
  const [CountItems, setCountItems] = useState(0);
  const [ShowOkAlert, setShowOkAlert] = useState(false);
  const [UploadInv, setUploadInv] = useState(false);
  const [SaveInv, setSaveInv] = useState(true);
  const [Okmessage, setOkmessage] = useState("");
  const [Oktitle, setOktitle] = useState("");
  const [InvoiceDirectory, setInvoiceDirectory] = useState("");

  const [ExpDays, setExpDays] = useState("90");
  const [MinQuantity, setMinQuantity] = useState("3");

  const ItemIDRef = useRef(null);
  const QBulkRef = useRef(null);
  const QUnitRef = useRef(null);
  const CostPriceRef = useRef(null);
  const TotalCostPriceRef = useRef(null);
  const ConverterRef = useRef(null);
  const SP1Ref = useRef(null);
  const SP2Ref = useRef(null);
  const SP3Ref = useRef(null);
  const UP1Ref = useRef(null);
  const UP2Ref = useRef(null);
  const UP3Ref = useRef(null);

  // const { addToast } = useToasts();

  const getSupplierDetails = () => {
    setOpenSupplyForm(true);
  };

  // useEffect(() => {
  //   if (ItemIDRef.current && OpenSupplyForm) {
  //     ItemIDRef.current.focus();
  //   }
  // }, [OpenSupplyForm]);

  useEffect(() => {
    ItemsEntered.length < 1 ? setSaveInv(true) : setSaveInv(false);
  }, [ItemsEntered]);

  useEffect(() => {
    // if (AllDates.length > 0) {
    if (Dates != "") {
      let SD = Dates.toString();
      setSingleDate(SD);
    }
    // }
  }, [Dates]);

  const getTotalPrice = () => {
    let tcp = 0;
    let upp = 0;
    let ccp =
      CostPriceRef.current.value != ""
        ? parseFloat(CostPriceRef.current.value)
        : 0;

    let cqu =
      QUnitRef.current.value != "" ? parseFloat(QUnitRef.current.value) : 0;

    upp = cqu * ccp;

    let t = upp;
    setTotalCostPrice(t);
    return t;
  };

  const nextOKEvent = () => {
    PCtx.GetCookiesValue();
    setShowOkAlert(false);
    window.location.reload();
  };

  const SoldInChange = (iv) => {
    setSoldIn(iv);
    setbulkvalue(iv);
    if (iv === "Unit" || iv === "Piece") {
      setConverter("1");
      setconvreadonly(true);
      setItHasBulk(false);
      setQBulk("");
    } else {
      setConverter("1");
      setconvreadonly(false);
      setItHasBulk(false);
    }
  };

  const CheckUnitPrice = () => {
    setcheckup(!checkup);
  };

  const CheckBulkPrice = () => {
    setchecksp(!checksp);
  };

  // To load stored items from the database
  useEffect(() => {
    let Allnames = [];
    let AllIDs = [];
    const getData = async () => {
      let AllGoods = await PCtx.connectAxios("getallgoods.php", "");

      for (var y = 0; y < AllGoods.length; y++) {
        AllIDs[y] = AllGoods[y][0];
        Allnames[y] = AllGoods[y][1];
      }
    };
    getData();
    setAllGoodNames(Allnames);
    setAllGoodIds(AllIDs);
  }, []);

  useEffect(() => {
    if (OpenSupplyForm) {
      let up = parseFloat(CostPriceRef.current.value);
      if (parseFloat(UP1Ref.current.value) >= 0 && UP1Ref.current.value < up) {
        PCtx.displayAlert(
          "Selling Price Error",
          "The Unit Selling Price 1 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
          "danger"
        );

        setErrorUP1(true);
      } else {
        setErrorUP1(false);
      }
      if (parseFloat(UP2Ref.current.value) >= 0 && UP2Ref.current.value < up) {
        PCtx.displayAlert(
          "Selling Price Error",
          "The Unit Selling Price 2 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
          "danger"
        );
        setErrorUP2(true);
      } else {
        setErrorUP2(false);
      }
      if (parseFloat(UP3Ref.current.value) >= 0 && UP3Ref.current.value < up) {
        PCtx.displayAlert(
          "Selling Price Error",
          "The Unit Selling Price 3 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
          "danger"
        );
        setErrorUP3(true);
      } else {
        setErrorUP3(false);
      }
    }
  }, [checkup]);

  useEffect(() => {
    let itdetails = [
      {
        title: "Item Name",
        value: Itemname === "" ? "No item selected" : Itemname,
      },

      {
        title: "Quantity left (Unit)",
        value: IQUnit === "" ? 0 : IQUnit,
      },
      {
        title: "Cost Price",
        value: CostPrice === "" ? "₦0" : "₦" + CostPrice,
      },

      {
        title: " Unit Selling Price 1",
        value: IUP1 === "" ? "₦0" : "₦" + IUP1,
      },
      {
        title: " Unit Selling Price 2",
        value: IUP2 === "" ? "₦0" : "₦" + IUP2,
      },
      {
        title: " Unit Selling Price 3",
        value: IUP3 === "" ? "₦0" : "₦" + IUP3,
      },
    ];

    setItemdetails(itdetails);
  }, [ItemHasChanged]);

  //To get the item picked
  const getItemnameSelection = async (it) => {
    let goodproperties = await PCtx.connectAxios("getitemdetails.php", it);

    setGoodID(goodproperties.GoodID);
    setSoldIn(goodproperties.Soldin);
    setCostPrice(goodproperties.CostPrice);
    setConverter(goodproperties.Converter);
    setIConverter(goodproperties.Converter);

    setUP1(goodproperties.UP1);
    setUP2(goodproperties.UP2);
    setUP3(goodproperties.UP3);

    setIUP1(goodproperties.UP1);
    setIUP2(goodproperties.UP2);
    setIUP3(goodproperties.UP3);

    setIQUnit(goodproperties.QUnit);
    setItemHasChanged(!ItemHasChanged);
    setItHasBulk(false);
    setExpDays(goodproperties.MExp);
    setMinQuantity(goodproperties.MQua);
  };

  const getTypedText = () => {
    let ITN = Itemname.charAt(0).toUpperCase() + Itemname.slice(1);
    if (AllGoodNames.includes(ITN)) {
      getItemnameSelection(ITN);
    } else {
      setSoldIn("Unit");
      setCostPrice("");
      setTotalCostPrice("");
      setQUnit("");
      setConverter("1");
      setUP1("");
      setUP2("");
      setUP3("");
    }
  };

  //To update total invoice income when itemsenetered is deleted from the table at the right handside
  useEffect(() => {
    let sm = 0;
    ItemsEntered.map((ite) => {
      sm = sm + parseFloat(ite.myTotalCostPrice);
    });
    setTotalInvoiceCost(sm);
  }, [ItemsEntered]);

  const deletethisitem = (count, tt) => {
    let itmEnt = ItemsEntered.filter((itm) => itm.myCount != count);
    setItemsEntered(itmEnt);
  };

  const CancelUpload = () => {
    setUploadInv(false);
    setHasNotUploaded(false);
  };

  //Submitting the supply form
  const submitItemForm = (e) => {
    e.preventDefault();

    if (ErrorSP1 || ErrorSP2 || ErrorSP3 || ErrorUP1 || ErrorUP2 || ErrorUP3) {
      PCtx.displayAlert(
        "ERROR",
        Itemname +
          " cannot be added. Please check the value(s) highlighted in Red.",
        "danger"
      );
    } else {
      let rep = "";
      let gid = "";
      let IsNewItem = true;
      let totalcp = getTotalPrice();
      if (!ItemsEntered.some((it) => it.myItemname === Itemname)) {
        if (AllGoodNames.includes(Itemname)) {
          IsNewItem = false;
          let sp1 = SP1 === "" ? 0 : SP1;
          let sp2 = SP2 === "" ? 0 : SP2;
          let sp3 = SP3 === "" ? 0 : SP3;
          let up1 = UP1 === "" ? 0 : UP1;
          let up2 = UP2 === "" ? 0 : UP2;
          let up3 = UP3 === "" ? 0 : UP3;
          let isp1 = ISP1 === "" ? 0 : ISP1;
          let isp2 = ISP2 === "" ? 0 : ISP2;
          let isp3 = ISP3 === "" ? 0 : ISP3;
          let iup1 = IUP1 === "" ? 0 : IUP1;
          let iup2 = IUP2 === "" ? 0 : IUP2;
          let iup3 = IUP3 === "" ? 0 : IUP3;

          if (parseFloat(sp1) !== parseFloat(isp1)) {
            rep +=
              PCtx.Username +
              " Changed the " +
              SoldIn +
              " price 1 of " +
              Itemname +
              " from " +
              isp1 +
              " to " +
              sp1;
          }
          if (parseFloat(sp2) !== parseFloat(isp2)) {
            rep +=
              PCtx.Username +
              " Changed the " +
              SoldIn +
              " price 2 of " +
              Itemname +
              " from " +
              isp2 +
              " to " +
              sp2;
          }
          if (parseFloat(sp3) !== parseFloat(isp3)) {
            rep +=
              PCtx.Username +
              " Changed the " +
              SoldIn +
              " price 3 of " +
              Itemname +
              " from " +
              isp3 +
              " to " +
              sp3;
          }

          if (parseFloat(up1) !== parseFloat(iup1)) {
            rep +=
              PCtx.Username +
              " Changed the Unit price 1 of " +
              Itemname +
              " from " +
              iup1 +
              " to " +
              up1;
          }
          if (parseFloat(up2) !== parseFloat(iup2)) {
            rep +=
              PCtx.Username +
              " Changed the Unit price 2 of " +
              Itemname +
              " from " +
              iup2 +
              " to " +
              up2;
          }
          if (parseFloat(up3) !== parseFloat(iup3)) {
            rep +=
              PCtx.Username +
              "Changed the Unit price 3 of " +
              Itemname +
              " from " +
              iup3 +
              " to " +
              up3;
          }
          if (parseFloat(Converter) !== parseFloat(IConverter)) {
            rep +=
              PCtx.Username +
              "Changed the quantity in one " +
              SoldIn +
              " of " +
              Itemname +
              " from " +
              IConverter +
              " to " +
              Converter;
          }
        } else {
          gid = Date.now() + Math.floor(Math.random() * 100 + 0);
          gid = gid.toString();
          gid = GoodID === "" ? "G" + gid : GoodID;
          setGoodID(gid);
        }

        const supplyproperties = {
          myCount: CountItems,
          myItemname: Itemname,
          mySoldIn: "Unit",
          myQUnit: QUnitRef.current.value != "" ? QUnitRef.current.value : 0,
          myCostPrice:
            CostPriceRef.current.value != "" ? CostPriceRef.current.value : 0,
          myTotalCostPrice: totalcp != "" ? totalcp : 0,
          myConverter: 1,
          myUP1: UP1Ref.current.value,
          myUP2: UP2Ref.current.value,
          myUP3: UP3Ref.current.value,
          logreport: rep,
          isNew: IsNewItem,
          myGID: IsNewItem ? gid : GoodID,
          MinExpDay: ExpDays,
          MinQuan: MinQuantity,
          EDate: SingleDate,
        };

        setItemsEntered([...ItemsEntered, supplyproperties]);

        setCountItems((prevCountItems) => prevCountItems + 1);
        setItemname("");
        setGoodID("");
        setSoldIn("Unit");
        setQUnit("");
        setCostPrice("");
        setConverter("");
        setIConverter("");
        setTotalCostPrice("");
        setConverter("1");

        setUP1("");
        setUP2("");
        setUP3("");
        setIUP1("");
        setIUP2("");
        setIUP3("");
        setIQUnit("");
        setIConverter("");
        setAxiosError("");
        setbulkvalue("Unit");
        setSingleDate("");
        setDates("");
        setcheckup(true);

        setErrorUP1(false);
        setErrorUP2(false);
        setErrorUP3(false);
        setItHasBulk(false);
        setconvreadonly(false);
        setItemHasChanged(false);
        setExpDays("90");
        setMinQuantity("3");
        setItemdetails([]);

        // ItemIDRef.current.focus();
      } else {
        PCtx.displayAlert(
          "ERROR",
          "Oops! " +
            Itemname +
            " cannot be added again because it has been added to the list already. Please check the list at the right hand side for confirmation.",
          "danger"
        );
      }
    }
  };

  const setTheItemChange = (vl) => {
    setItemname(vl);
    if (!AllGoodNames.includes(vl) && AllGoodIds.includes(GoodID)) {
      setGoodID("");
    }
  };

  const setTheItemID = (vl) => {
    vl = vl.replace(/[^a-zA-z0-9]/g);
    vl = vl.replace(/\n/g, "");
    setQUnit("");

    if (AllGoodIds.includes(vl)) {
      let index = AllGoodIds.indexOf(vl);
      let item = AllGoodNames[index];
      setItemname(item);
      getItemnameSelection(item);
      if (QUnitRef.current && OpenSupplyForm) {
        // QUnitRef.current.focus();
      }
    }
    setGoodID(vl);
  };

  const SaveTheSupply = async () => {
    let DetailsToServer = {
      Supplier: Supplier,
      Invoice: InvoiceNumber,
      Staff: PCtx.Username,
      suprecords: ItemsEntered,
      invoicepix: InvoiceDirectory,
    };
    let resp = await PCtx.connectAxios("insertandupdate.php", DetailsToServer);

    if (resp.includes("Error")) {
      PCtx.displayAlert(
        "ERROR IN SAVING ITEM",
        "There was an error in saving " +
          Itemname +
          ". Please check all the values you supplied again",
        "danger"
      );
    } else {
      setOkmessage("All Items saved successfully.");
      setOktitle("SUCCESS!");
      setShowOkAlert(true);
    }
  };
  return (
    <div>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Divider>
                <h3
                  className="text-center"
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  NEW SUPPLY
                </h3>
              </Divider>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {!OpenSupplyForm && (
        <Row className="mt-5 justify-content-around">
          <Col md={4} sm={12} xs={12}>
            <Form onSubmit={getSupplierDetails}>
              <Card>
                <Card.Header>Customer's Details</Card.Header>
                <Card.Body>
                  <Form.Group className="mb-0">
                    <Form.Label style={{ color: "brown" }}>
                      Supplier's Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={Supplier}
                      name="custname"
                      onChange={(e) => setSupplier(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label style={{ color: "brown" }}>
                      Invoice Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={InvoiceNumber}
                      name="custphone"
                      onChange={(e) => setInvoiceNumber(e.target.value)}
                    />
                  </Form.Group>
                </Card.Body>
                <Card.Footer>
                  <Row className="justify-content-end">
                    <Col md={4} sm={4} xs={4}>
                      <Button variant="info" type="submit">
                        Enter Items
                      </Button>
                    </Col>
                  </Row>
                </Card.Footer>
              </Card>
            </Form>
          </Col>
        </Row>
      )}
      {OpenSupplyForm && (
        <Row className="px-1">
          <Col md={2} className={classes.dd}>
            <Card>
              <Card.Header
                className="text-center text-bg"
                style={{ color: "brown", fontFamily: "Times New Roman" }}
              >
                DETAILS OF SELECTED ITEM
              </Card.Header>
            </Card>
            {Itemdetails.map((itd, index) => (
              <Card key={index} className="w-100">
                <Card.Body
                  className="my-0 py-1  pl-3"
                  style={{
                    backgroundColor: index % 2 === 0 ? "#c0c0c0" : "#dfdfdf",
                    paddingLeft: "30px",
                  }}
                >
                  <h6 style={{ color: "brown", fontFamily: "Times New Roman" }}>
                    {itd.title}:
                  </h6>
                  <h5 style={{ color: "black", paddingLeft: "30px" }}>
                    {itd.value}
                  </h5>
                </Card.Body>
              </Card>
            ))}
          </Col>
          <Col md={6} sm={12} xs={12}>
            <Card>
              <Card.Header
                className="text-center text-bg"
                style={{ color: "brown", fontFamily: "Times New Roman" }}
              >
                SUPPLY FROM {Supplier.toUpperCase()}
              </Card.Header>
              <Card.Body>
                <Form onSubmit={submitItemForm}>
                  {/* <Row>
                  <Col>
                    <BarcodeScannerComponent
                      width={500}
                      height={500}
                      onUpdate={(err, result) => {
                        if (result) {
                          setItemname(result.text);
                        } else {
                          setItemname("Error");
                        }
                      }}
                    />
                  </Col>
                </Row> */}
                  <Row className="justify-content-around">
                    {/* <Col md={6}>
                      <InputText
                        label="Item Number"
                        labelcolor="brown"
                        myVal={GoodID}
                        myName="ItemId"
                        myOnChange={setTheItemID}
                        inputType="number"
                        myRef={ItemIDRef}
                        // getAction={getTotalPrice}
                      />
                      <hr className="m-1 p-1" />
                    </Col> */}

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label style={{ color: "brown" }}>
                          Item Name
                        </Form.Label>
                        <AutoComplete
                          data={AllGoodNames}
                          value={Itemname}
                          onChange={setTheItemChange}
                          onSelect={getItemnameSelection}
                          onBlur={getTypedText}
                          style={{ border: "1px solid brown" }}
                        />
                      </Form.Group>
                    </Col>
                    <hr className="m-1 p-1" />
                  </Row>

                  <Row>
                    <Col md={4}>
                      <InputText
                        label="Quantity Supplied in Units"
                        labelcolor="brown"
                        myVal={QUnit ? QUnit : 0}
                        myRef={QUnitRef}
                        myName="QUnit"
                        myOnChange={setQUnit}
                        inputType="number"
                        getAction={getTotalPrice}
                        readonly={Itemname === "" ? true : false}
                      />
                      <hr />
                    </Col>
                    <Col md={4}>
                      <InputText
                        label={"Cost Price of a Unit"}
                        labelcolor="brown"
                        myVal={CostPrice ? CostPrice : 0}
                        myRef={CostPriceRef}
                        myName="CostPrice"
                        getAction={getTotalPrice}
                        myOnChange={setCostPrice}
                        inputType="number"
                        readonly={Itemname === "" ? true : false}
                      />
                      <hr />
                    </Col>
                    <Col md={4}>
                      <InputText
                        label="Total Cost Price"
                        labelcolor="brown"
                        myVal={TotalCostPrice}
                        myRef={TotalCostPriceRef}
                        myName="TotalCostPrice"
                        myOnChange={getTotalPrice}
                        readonly={true}
                        inputType="number"
                      />

                      <hr />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <InputText
                        label="One Unit Selling Price 1"
                        labelcolor="brown"
                        myVal={UP1}
                        myRef={UP1Ref}
                        myName="UP1"
                        myOnChange={setUP1}
                        inputType="number"
                        getAction={CheckUnitPrice}
                        error={ErrorUP1}
                        readonly={Itemname === "" ? true : false}
                      />
                      <hr />
                    </Col>
                    <Col md={4}>
                      <InputText
                        label="One Unit Selling Price 2"
                        labelcolor="brown"
                        myVal={UP2}
                        myRef={UP2Ref}
                        myName="UP2"
                        myOnChange={setUP2}
                        inputType="number"
                        getAction={CheckUnitPrice}
                        error={ErrorUP2}
                        placeholder="Optional"
                        readonly={
                          Itemname === "" || SoldIn === "" ? true : false
                        }
                      />
                      <hr />
                    </Col>
                    <Col md={4}>
                      <InputText
                        label="One Unit Selling Price 3"
                        labelcolor="brown"
                        myVal={UP3}
                        myRef={UP3Ref}
                        myName="UP3"
                        myOnChange={setUP3}
                        inputType="number"
                        getAction={CheckUnitPrice}
                        error={ErrorUP3}
                        readonly={
                          Itemname === "" || SoldIn === "" ? true : false
                        }
                        placeholder="Optional"
                      />
                      <hr />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4} sm={4}>
                      <Form.Label style={{ color: "brown" }}>
                        Expiry Date
                        <br />
                        <DatePicker
                          value={Dates}
                          editable={false}
                          style={{
                            height: "40px",
                            width: "190px",
                            backgroundColor: "White",
                            boxShadow: "5px 5px #b1b1b1",
                            marginTop: "8px",
                          }}
                          placeholder="Click me to open calendar!"
                          onChange={(dateObjects) => {
                            setDates(dateObjects);
                          }}
                          format="MMM DD, YYYY"
                          range={DateCategory === "range" ? true : false}
                          shadow={true}
                          readonly={parseFloat(QUnit) > 0 ? false : true}
                        />
                      </Form.Label>
                    </Col>
                    <Col md={4} lg={4}>
                      <InputText
                        label="Expiry Alert Days"
                        labelcolor="brown"
                        myVal={ExpDays}
                        myName="ExpDays"
                        myOnChange={setExpDays}
                        inputType="number"
                      />
                    </Col>
                    <Col md={4} lg={4}>
                      <InputText
                        label="Minimum Quantity Alert"
                        labelcolor="brown"
                        myVal={MinQuantity}
                        myName="MinQuantity"
                        myOnChange={setMinQuantity}
                        inputType="number"
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-around">
                    <Col md={4} sm={4} xs={4}>
                      <Button type="submit" disabled={QUnit === ""}>
                        Add Item
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={12} xs={12}>
            <Card>
              <Card.Header>
                <Row>
                  <Col>Supplier: {Supplier}</Col>
                  <Col>Invoice No: {InvoiceNumber}</Col>
                </Row>
              </Card.Header>
              <Card.Body
                style={{
                  height: "500px",
                  overflowY: "scroll",
                  marginButtom: "20px",
                }}
              >
                <Table
                  striped
                  bordered
                  hover
                  style={{ fontFamily: "Times New Roman" }}
                >
                  <thead>
                    <tr>
                      <td>SN</td>
                      <td>Item name</td>
                      <td>Unit</td>
                      <td>Total Cost</td>
                      <td>Del</td>
                    </tr>
                  </thead>
                  <tbody>
                    {ItemsEntered.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.myItemname}</td>
                        <td>{item.myQUnit}</td>
                        <td>{item.myTotalCostPrice}</td>
                        <td>
                          <Button
                            className="btn-small"
                            onClick={() =>
                              deletethisitem(
                                item.myCount,
                                item.myTotalCostPrice
                              )
                            }
                          >
                            -
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>

              <Row className="justify-content-around">
                <Col md={12} sm={12} xs={12} className="my-2 text-center">
                  <p className={classes.tic}>
                    Total Invoice Cost: {"₦" + TotalInvoiceCost}
                  </p>
                </Col>
                <Col md={6} sm={12} xs={12} className="my-2 text-center">
                  {HasNotUploaded && (
                    <Button
                      variant="success"
                      onClick={() => setUploadInv(true)}
                    >
                      Upload Invoice
                    </Button>
                  )}
                </Col>
                <Col md={6} sm={12} xs={12} className="my-2 text-center">
                  <Button
                    variant="success"
                    onClick={SaveTheSupply}
                    disabled={SaveInv}
                  >
                    Save All Items
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
          <ModalOkay
            message={Okmessage}
            okshow={ShowOkAlert}
            title={Oktitle}
            nextEvent={nextOKEvent}
          />
          {UploadInv && (
            <UploadInvoiceModal
              cancelModal={CancelUpload}
              showmodal={UploadInv}
              setInvoicePix={setInvoiceDirectory}
            />
          )}
        </Row>
      )}
    </div>
  );
};

export default SupplyIn;
